export const mediaUrl = (path: string) => {
    if (!path) return null;
    return `${(process.env.EXPO_PUBLIC_CMS?.includes('localhost') || process.env.EXPO_PUBLIC_CMS?.includes('192.168.')) && path ? process.env.EXPO_PUBLIC_CMS : ''}${path}`;
}
